import { ExpertAdvice } from "@/common/api.service";
import {
  FETCH_EXPERT_PROJECT,
  FETCH_EXPERT_PROJECT_LIST
} from "./actions.type";
import { FETCH_EA_END, FETCH_EA_START } from "@/store/mutations.type";

const state = {
  experts_project: {},
  isEAsLoading: false,
  experts_projects: {
    counts: 0,
    items: [],
    itemsCount: []
  }
};

const getters = {
  experts_project() {
    return state.experts_project;
  },
  isEAsLoading() {
    return state.isEAsLoading;
  },
  experts_projects() {
    return state.experts_projects;
  }
};

const actions = {
  async [FETCH_EXPERT_PROJECT]({ state }, id) {
    await ExpertAdvice.list(id)
      .then(({ data }) => {
        state.experts_project = data;
      })
      .catch(error => {
        throw new Error(error);
      });
  },
  async [FETCH_EXPERT_PROJECT_LIST]({ commit }, params) {
    commit(FETCH_EA_START);
    return ExpertAdvice.getListProjectsAdvice(params.id, params)
      .then(({ data }) => {
        commit(FETCH_EA_END, data);
      })
      .catch(error => {
        throw new Error(error);
      });
  }
};

const mutations = {
  [FETCH_EA_START](state) {
    state.isEAsLoading = true;
  },
  [FETCH_EA_END](state, experts_projects) {
    state.experts_projects = experts_projects;
    state.isEAsLoading = false;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
